import React, { useEffect, useMemo, useRef } from "react";

import { useDispatch, useSelector } from "react-redux";

import { InsidersCloseButton } from "@app/components";
import { Case, CaseElse, Switch } from "@app/contexts";
import {
  InsiderNotSynced,
  LoginToInsider,
} from "@app/pages/startup/VerificationRequired";
import * as appConst from "@app/state/constants";
import { insLogout, selectInsLogin } from "@app/state/insider/login";
import { selectUserEmail, whoamiAsLonleyUser } from "@app/state/units/login";
import { selectInsiderContext } from "@app/state/units/ui/groupstree";
import { useFxDispatch } from "@app/statefx";
import { sfxInLogout } from "@app/statefx/xThunks/login";
import { TInsLoginData } from "@app/types";

type TInsiderGateProp = {
  childName: string;
  toggleDrawer: (bool?: boolean) => void;
  userData: {
    AMAID: number;
    PERSEED: string;
    GROUPID: number;
    GROUP_NAME: string;
  };
};
const InsiderGateCtx = React.createContext<TInsiderGateProp>({
  childName: "",
  toggleDrawer: () => void 0,
  userData: { AMAID: 0, PERSEED: "", GROUPID: 0, GROUP_NAME: "" },
});

const gateData = {
  AMAID: 0,
  PERSEED: "",
  GROUPID: 0,
  GROUP_NAME: "",
};
export const InsiderGate = ({
  children,
  childName,
  toggleDrawer,
}: {
  children: any;
  childName: string;
  toggleDrawer: (bool?: boolean) => void;
}) => {
  const chnRef = useRef({ childName: "" });
  chnRef.current.childName = childName;
  const [gateState, setGateState] = React.useState(gateData);
  const theInsiderChecks = useSelector(selectInsiderContext);
  const myHomeCode = useSelector(whoamiAsLonleyUser);
  const userEmail = useSelector(selectUserEmail);
  const insLogin: TInsLoginData = useSelector(selectInsLogin);
  const dispatch = useDispatch();
  const fxDispatch = useFxDispatch();
  React.useEffect(() => {
    const { AMAID, PERSEED, GROUPID, GROUP_NAME } =
      theInsiderChecks || gateData;
    setGateState({ AMAID, PERSEED, GROUPID, GROUP_NAME });
    return () => {
      setGateState(gateData);
    };
  }, [theInsiderChecks]);

  const body = useMemo(
    () =>
      `Contul nesincronizat cu baza de date ${gateState.GROUP_NAME}/${myHomeCode}`,
    [gateState.GROUP_NAME, myHomeCode]
  );
  const mainRequestValidButWithoutID = useMemo(
    () => gateState.GROUPID > 0 && gateState.PERSEED.length > 2,
    [gateState.GROUPID, gateState.PERSEED]
  );
  const mainRequestIsValid = useMemo(
    () => mainRequestValidButWithoutID && gateState.AMAID > 0,
    [mainRequestValidButWithoutID, gateState.AMAID]
  );
  const insiderLoginIsSet = insLogin.AMAXAVOID > 0;

  //a twisted validation //
  const insiderLoginIsValid =
    insiderLoginIsSet &&
    insLogin.LOGINCTX === `${gateState.GROUPID}/${myHomeCode}`;

  const execToggle = (bool?: boolean) => {
    toggleDrawer(bool);
  };
  const value = {
    childName,
    toggleDrawer: execToggle,
    userData: gateState,
  };
  useEffect(() => {
    return () => {
      dispatch(insLogout());
      fxDispatch(sfxInLogout());
    };
  }, []);
  return (
    <InsiderGateCtx.Provider value={value}>
      {/* if no report loaded for instance, or ... ??? */}
      {!mainRequestIsValid && <InsidersCloseButton toggleDrawer={execToggle} />}
      <Switch value={mainRequestIsValid}>
        {/* THIS IS THE WORK ZONE */}
        <Case
          when={[(isValid: boolean) => isValid === true && insiderLoginIsValid]}
        >
          {children}
        </Case>
        {/* FROM HERE BELOW THERE ARE TEMPORARY OR NOT ALLOWED STATES */}
        <Case
          when={[
            (isValid: boolean) => isValid === true && !insiderLoginIsValid,
          ]}
        >
          <Switch value={insiderLoginIsSet}>
            <Case when={false}>
              <Switch value={childName}>
                <Case when={appConst.DRAWER_PAGES.INSIDERS}>
                  {/* show some message and login */}
                  <LoginToInsider
                    ClientName={gateState.GROUP_NAME}
                    gEmail={`${gateState.GROUPID}/${userEmail}`}
                  />
                </Case>
              </Switch>
            </Case>
            <Case when={true}>
              <Switch value={childName}>
                <Case when={appConst.DRAWER_PAGES.INSIDERS}>
                  {/* show some message and logout */}
                  <div>
                    {
                      "DANGERSOUSLY OTHER EMAIL THAT WE EXPECTED InsiderGate - invalid"
                    }
                  </div>
                </Case>
              </Switch>
            </Case>
          </Switch>
        </Case>
        <Case
          when={[
            (isValid: boolean) =>
              isValid === false && mainRequestValidButWithoutID,
          ]}
        >
          <Switch value={childName}>
            <Case when={appConst.DRAWER_PAGES.INSIDERS}>
              <InsiderNotSynced body={body} />
            </Case>
          </Switch>
        </Case>
        <Case
          when={[
            (isValid: boolean) =>
              isValid === false && !mainRequestValidButWithoutID,
          ]}
        >
          <Switch value={childName}>
            <Case when={appConst.DRAWER_PAGES.INSIDERS}>
              {/* show some message and logout */}
              <div>{"Out of scope, invalid request"}</div>
            </Case>
          </Switch>
        </Case>
      </Switch>
    </InsiderGateCtx.Provider>
  );
};

export const useInsiderGate = () => {
  const data = React.useContext(InsiderGateCtx);
  return data;
};
